import CourseListingMainComponent from "./CourseListingMainComponent";

const CourseListingMyCourse =()=>{


    return (<>
        <CourseListingMainComponent
        isAllCourse={false}
        isMyCourse={true}
        isFilterShow={false}
        isPopular={false}
        tabKey={"MyCourses"} />
        </>)
}
export default CourseListingMyCourse;